interface BreakpointsInterface {
  xs: string;
  sm: string;
  md: string;
  lg: string;
}

/**
 * Mobile:    Between 320-480 pixels.
 * Tablets:   Between 481-768 pixels.
 * Laptops:   Between 769-1024 pixels.
 * Desktops:  Between 1024-1200 pixels.
 * TV:        From 1201 pixels.
 */
export const breakpoints: BreakpointsInterface = {
  xs: '480px',
  sm: '768px',
  md: '1024px',
  lg: '1200px',
};

export const WEDO_DEFAULT_WIDTH = '960px';
